import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { initApp } from './redux/appSlice';
import { Main } from './pages/Main';
import { Login } from './pages/Login';
import { Preloader } from './components/Preloader';

function App() {
    const dispatch = useDispatch();
    const isAuth = useSelector(state => state.auth.isAuth);
    const isLightTheme = useSelector(state => state.app.isLightTheme);

    const isInitApp = useSelector(state => state.app.isLoaded);

    useEffect(() => {
        dispatch(initApp());
    }, []); //isAuth

    useEffect(() => {
        const handleWheel = (event) => {
            if (event.ctrlKey) {
                event.preventDefault();
            }
        };
        document.addEventListener('wheel', handleWheel, { passive: false });
        return () => {
            document.removeEventListener('wheel', handleWheel);
        };
    }, []);

    return (
        <div className={`App ${isLightTheme ? 'theme_light' : 'theme_dark'}`}>
            {!isInitApp
            ? <Preloader fullscreen={true} />
            : <Routes>
                <Route path="/login" element={<Login />}></Route>
                <Route path="*" element={<Main isAuth={isAuth} />}></Route>
            </Routes>}
        </div>
    );
}

export default App;
